import { Component, Input, Output, EventEmitter, HostListener } from '@angular/core';
import * as _ from 'lodash';
import { SharedService } from 'app/shared/services/shared.service';
import { DictionaryService } from 'app/shared/services/dictionary.service';

@Component({
  selector: 'dropdown-component',
  templateUrl: './dropdown.component.html',
  styleUrls: ['./dropdown.component.scss'],
})
export class DropdownComponent {
  @Input() public items: Array<any>;
  @Input() public selectedItemIndex: number;
  @Input() public noSelectionLabel: string;
  @Input() public showResetSelectionItem: boolean;
  @Input() public allowCustomValues: boolean;
  @Input() public tooltips: boolean;
  @Input() public disabled: boolean;
  @Input() public noBorder: boolean;
  @Input() public showBackground: boolean;
  @Input() public wrapperClass: string;
  @Output() public onChange: EventEmitter<any>;

  public id: string;
  public toggleState: boolean;
  public customValue: string;
  public filteredItems: Array<any>;

  constructor(public sharedService: SharedService, public dictionaryService: DictionaryService) {
    this.id = 'dropdownComponent_' + new Date().getTime() + '_' + Math.round(Math.random() * 9999);
    this.toggleState = false;
    this.items = [];
    this.filteredItems = [];
    this.selectedItemIndex = -1;
    this.noSelectionLabel = this.dictionaryService.get('SELECT');
    this.showResetSelectionItem = false;
    this.allowCustomValues = false;
    this.tooltips = true;
    this.disabled = false;
    this.customValue = '';
    this.wrapperClass = '';
    this.onChange = new EventEmitter<number>();
    this.noBorder = false;
    this.showBackground = false;
  }

  ngOnChanges() {
    this.items = _.uniq(this.items);
  }

  toggleDropdown() {
    if (this.disabled) { return false; }

    let me: HTMLElement;
    let inputs: any;
    let dropdownItemSelected: any;
    this.toggleState = !this.toggleState;
    if (this.toggleState) {
      this.filteredItems = _.cloneDeep(this.items);
      this.customValue = '';
      setTimeout(() => {
        me = document.getElementById(this.id);
        inputs = me.getElementsByTagName('input');
        dropdownItemSelected = me.getElementsByClassName('dropdownItemSelected');
        if (inputs.length > 0) {
          inputs[0].focus();
        }
        if (dropdownItemSelected.length > 0) {
          me.getElementsByClassName('dropdownItems')[0].scrollTop = dropdownItemSelected[0].offsetTop;
        }
      });
    }
  }

  onItemSelect(item: any) {
    const customValue: string = this.customValue;
    let existingItem: any;
    if (item !== 'custom') {
      this.selectedItemIndex = _.findIndex(this.items, this.filteredItems[item]);
    } else {
      if (this.sharedService.isEmpty(this.customValue)) {
        this.selectedItemIndex = -1;
      } else {
        existingItem = _.find(this.items, function (o) {
          return o.label.toLowerCase() === customValue.toLowerCase();
        });
        if (existingItem) {
          this.selectedItemIndex = this.items.indexOf(existingItem);
        } else {
          this.items.push({
            label: this.customValue,
            value: -1,
            tooltip: this.customValue,
          });
          this.selectedItemIndex = this.items.length - 1;
        }
      }
    }
    this.toggleState = false;
    this.selectedItemIndex === -1 ? this.onChange.emit(null) : this.onChange.emit(this.items[this.selectedItemIndex]);
  }

  onCustomValueChange() {
    const customValue: string = this.customValue;
    if (this.sharedService.isEmpty(customValue)) {
      this.filteredItems = _.cloneDeep(this.items);
    } else {
      this.filteredItems = _.filter(this.items, function (o) {
        return o.label ? o.label.toLowerCase().indexOf(customValue.toLowerCase()) > -1 : false;
      });
    }
  }

  onKeyDown($event) {
    if ($event.which === 13) {
      this.onItemSelect('custom');
    }
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick($event: any) {
    let clickedOnDropdown = false;
    let index = 0;
    const path: any =
      $event.path ||
      ($event.composedPath && $event.composedPath($event.target)) ||
      this.sharedService.composedPath($event.target);
    while (!clickedOnDropdown && index < path.length) {
      clickedOnDropdown = path[index].id === this.id;
      if (!clickedOnDropdown) {
        index++;
      }
    }
    if (!clickedOnDropdown) {
      this.toggleState = false;
    }
  }
}
